import { render } from "./ThePassLowerDemand.vue?vue&type=template&id=4a94f434&scoped=true"
import script from "./ThePassLowerDemand.vue?vue&type=script&lang=js"
export * from "./ThePassLowerDemand.vue?vue&type=script&lang=js"

import "./ThePassLowerDemand.vue?vue&type=style&index=0&id=4a94f434&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a94f434"

export default script